import { render } from "./ConfirmDeposit.vue?vue&type=template&id=9ad2d3c0&scoped=true"
import script from "./ConfirmDeposit.vue?vue&type=script&lang=js"
export * from "./ConfirmDeposit.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositReview.scss?vue&type=style&index=0&id=9ad2d3c0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad2d3c0"]])

export default __exports__